'use strict';

function updateCompletedBillingAddress () {
	const firstName = $('input[name="bill_to_forename"]').val();
    const lastName = $('input[name="bill_to_surname"]').val();
    const country = $('#bill-to-address-country option:selected').text();
    const companyName = $('input[name="bill_to_company_name"]').val();
    const address1 = $('input[name="bill_to_address_line1"]').val();
    const address2 = $('input[name="bill_to_address_line2"]').val();
    const city = $('input[name="bill_to_address_city"]').val();
    const state = $('input[name="county_field"]').val();
    const postalCode = $('input[name="bill_to_address_postal_code"]').val();

    $('.completed-billing-address .data').html(`
      <p data-cs-mask>${firstName} ${lastName}</p>
      <p data-cs-mask>${country}</p>
      <p data-cs-mask>${companyName}</p>
      <p data-cs-mask>${address1}</p>
      <p data-cs-mask>${address2}</p>
      <p data-cs-mask>${city}</p>
      <p data-cs-mask>${state}</p>
      <p data-cs-mask>${postalCode}</p>
    `);
}

module.exports = {
  updateCompletedBillingAddress: updateCompletedBillingAddress
};